import { render, staticRenderFns } from "./EditRetention.vue?vue&type=template&id=a2861dde&scoped=true&"
import script from "./EditRetention.vue?vue&type=script&lang=js&"
export * from "./EditRetention.vue?vue&type=script&lang=js&"
import style0 from "./EditRetention.vue?vue&type=style&index=0&id=a2861dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2861dde",
  null
  
)

export default component.exports